module.exports = __webpack_public_path__ + "img/content2Linux.0ab0fd84.svg";